import { render, staticRenderFns } from "./FullWidthSidebarLeft.vue?vue&type=template&id=500812be&"
import script from "./FullWidthSidebarLeft.vue?vue&type=script&lang=js&"
export * from "./FullWidthSidebarLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports